module.exports = __webpack_public_path__ + "static/media/h-icon.74142440.svg";